import type { UniqueIdentifier } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import type { SelectedThoughtDocument } from "../../types";

export type ArrangementReorderResult = {
  orderedThoughtIds: string[];
  reorderedThoughts: SelectedThoughtDocument[];
};

export function getSameListReorderResult(
  orderedThoughts: SelectedThoughtDocument[],
  activeId: UniqueIdentifier,
  overId: UniqueIdentifier | null | undefined,
): ArrangementReorderResult | null {
  if (!overId || activeId === overId) {
    return null;
  }

  const oldIndex = orderedThoughts.findIndex(
    (thought) => thought.objectID === activeId,
  );
  const newIndex = orderedThoughts.findIndex(
    (thought) => thought.objectID === overId,
  );

  if (oldIndex < 0 || newIndex < 0) {
    return null;
  }

  const reorderedThoughts = arrayMove(orderedThoughts, oldIndex, newIndex);

  return {
    orderedThoughtIds: reorderedThoughts.map((thought) => thought.objectID),
    reorderedThoughts,
  };
}
